<div class="col gap-4">
    <div class="w100 row space-between">
        <div class="col leftsidearea">
            <div class="row space-between gap-8 w100">
                <h1 class="strong">{{ streamInfo?.name }}</h1>
            </div>
            <div>Stream Description: {{ streamInfo?.description }}</div>
        </div>

        <div class="col gap-4 tiny align-end steparea">
            <span *ngIf="streamInfo?.dateCreate"
                >Created On:
                {{ streamInfo?.dateCreate! | getLocaldateByTime }}</span
            >
            <span
                *ngIf="
                    streamInfo?.creatingUserPrename || streamInfo?.creatingUserLastname
                "
                >Created By: {{ streamInfo?.creatingUserPrename }}
                {{ streamInfo?.creatingUserLastname }}</span
            >
            <span *ngIf="streamInfo?.dateUpdate"
                >Updated On:
                {{ streamInfo?.dateUpdate! | getLocaldateByTime }}</span
            >
            <span
                *ngIf="
                    streamInfo?.updatingUserPrename || streamInfo?.updatingUserLastname
                "
                >Updated By: {{ streamInfo?.updatingUserPrename }}
                {{ streamInfo?.updatingUserLastname }}
            </span>
            <rr-btn size="Small" type="Secondary">{{ streamInfo?.llmId }}</rr-btn>
        </div>
    </div>
    <div class="w100 row gap-40">
        <div class="row gap-8">
            <rr-badge tone="success">{{ streamInfo?.status }}</rr-badge>
            <rr-badge tone="info">{{ streamInfo?.type }}</rr-badge>
        </div>
        <div class="row gap-4">
            <rr-badge *ngFor="let cat of streamInfo?.categoryId">{{
                cat | getCategoryNameById
            }}</rr-badge>
        </div>
    </div>
</div>

<div class="row gap-24 h100 grow-1">
    <div class="contentarea card col w100">
        <!-- ========== CONFIG EDIT ==========  -->
         <div class="w100" *ngIf="!activeStep">
            <h3>User Sessions</h3>

            <div class="filter col space-between gap-24">
                <div *ngIf="selectedUser !== null" class="row w100">
                    <div class="row user-row space-between w100 align-center">
                        <div class="row gap-8">
                            <p>Selected User:</p>
                            <rr-user-avatar [user]="selectedUser"></rr-user-avatar>
                            <p>{{selectedUser.email}}</p>
                            <p *ngIf="selectedUser.prename && selectedUser.lastname">| {{selectedUser.prename}} {{selectedUser.lastname}}</p>
                        </div>
                        <rr-btn type="secondary" iconStart="close" (btnclick)="removeSelection()">Remove</rr-btn>
                    </div>
                </div>
                <rr-input
                    *ngIf="selectedUser == null"
                    type="search"
                    placeholder="Search by name or email"
                    [FormControl]="searchQuery"
                ></rr-input>
                <div class="col w100 gap-4" *ngIf="searchUsers.length > 0 && selectedUser == null">
                    <div *ngFor="let user of searchUsers" class="row user-row space-between w100 align-center">
                        <div class="row gap-8">
                            <rr-user-avatar [user]="user"></rr-user-avatar>
                            <p>{{user.email}}</p>
                            <p *ngIf="user.prename && user.lastname">| {{user.prename}} {{user.lastname}}</p>
                        </div>
                        <rr-btn type="secondary" (btnclick)="selectUser(user)">Select</rr-btn>
                    </div>
                </div>
                <div class="row gap-8">
                    <rr-segment-control (selectionChange)="changeTimeFilter($event)">
                        <rr-segment-control-item name="All"></rr-segment-control-item>
                        <rr-segment-control-item name="Today"></rr-segment-control-item>
                        <rr-segment-control-item name="Last 7 Days"></rr-segment-control-item>
                        <rr-segment-control-item name="Custom"></rr-segment-control-item>
                    </rr-segment-control>
                    <mat-form-field i18n *ngIf="selectionIndex === 3">
                        <mat-label>Enter a date range</mat-label>
                        <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [min]="minDate" [max]="maxDate">
                            <input matStartDate formControlName="start" placeholder="Start date">
                            <input matEndDate formControlName="end" placeholder="End date">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                    <rr-btn *ngIf="selectionIndex === 3" type="Primary" [disabled]="range.invalid" (btnclick)="onCustomSelect()">Select</rr-btn>
                </div>
            </div>

            <div class="col gap-8">
                <div class="w100 card col gap-8" *ngFor="let s of sessions">
                    <div class="row space-between w100">
                        <div class="col gap-4">
                            <div class="row gap-24 align-center">
                                <h4 class="strong">{{ getSessionLatestDate(s) ?? 0 | getLocaldateByTime }} | {{getAllSessionEntries(s)}} entries | {{ s.isLegacy ? 'LEGACY session' : (s.finished ? 'finished' : 'not finished')}}</h4>
                            </div>
                        </div>
                        <div class="row gap-8 align-center">
                            <rr-btn
                                iconStart="eye"
                                size="Small"
                                type="Secondary"
                                (btnclick)="selectSession(s)"
                                >View</rr-btn
                            >
                        </div>
                    </div>
                </div>
            </div>
         </div>
        <div class="stepedit w100" *ngIf="activeStep">
            <rr-btn type="secondary" iconStart="arrow-left" (btnclick)="back()">Back</rr-btn>
            <h4 class="strong session-header">{{ getSessionLatestDate(activeSession) ?? 0 | getLocaldateByTime }} | {{ activeSession.isLegacy ? 'LEGACY session' : (activeSession.finished ? 'finished' : 'not finished')}}</h4>
            <div class="w100 row space-between">
                <span
                    >Step {{ activeStepNumber }} /
                    {{ streamInfo?.steps?.length || 0 }}</span
                >
            </div>
            <div class="col w100 gap-64">
                

                <div class="col">
                    <h1>{{ activeStep.name }}</h1>
                    <div>{{ activeStep.description }}</div>
                    <div class="row gap-8 w100">
                        <rr-badge tone="success"
                            >Credits: {{ activeStep.credits }}</rr-badge
                        >
                        <rr-badge tone="information"
                            >Duration: {{ activeStep.duration }}</rr-badge
                        >
                        <rr-badge tone="warning"
                            >Websearch:
                            {{
                                activeStep.websearchStatus === false
                                    ? "NO"
                                    : "YES"
                            }}</rr-badge
                        >
                        <rr-badge tone="warning"
                            >File upload:
                            {{
                                activeStep.uploadStatus === false ? "NO" : "YES"
                            }}</rr-badge
                        >
                    </div>
                </div>
                <!-- <div
                    class="col w100 gap-8"
                    *ngIf="activeStep.requiredStepIds.length !== 0"
                >
                    <h3>Required Steps</h3>
                </div> -->
                <div class="col gap-16 w100">
                    <div class="col w100 entrie gap-8" *ngFor="let e of activeStep.entries">
                        <div>{{ e.dateCreate | getLocaldateByTime}}</div>
                        <div class="entrie-text prompt w100">
                            <div class="prompt-text">{{e.prompt}}</div>
                        </div>
                        <div class="entrie-text response w100">
                            <div class="response-text">{{e.response}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ========== CONFIG EDIT ==========  -->
    </div>
    <div class="steparea col gap-8" *ngIf="activeStep">
        <!-- For every Step -->
        <div
            class="row gap-16 singlestep exist"
            [ngClass]="activeStepNumber === i + 1 ? 'active' : ''"
            *ngFor="let step of activeSession?.steps; let i = index"
        >
            <div
                class="col justify-start gap-8 align-center align-self-stretch"
            >
                <div class="dot"></div>
                <div class="line grow-1"></div>
            </div>
            <div class="col stepoverviewcontent">
                <div class="row space-between w100 align-center">
                    <div class="row gap-8 align-center">
                        <h4
                            class="stepheadline"
                            (click)="setStepForView(step, i)"
                        >
                            {{ i + 1 }}. | {{ step.name }}
                        </h4>
                    </div>
                </div>
                <div class="stepcontent" (click)="setStepForView(step, i)">
                    <span class="conversations">{{getEntriesNumberForStep(step)}} entries</span><br>
                    {{ step.description }}
                </div>
            </div>
        </div>
    </div>
</div>

